import API from "@utils/plugins/API";

const CensusOverviewService = {
  all: (id) => {
    return API.get(`censuses/${id}/overview`);
  },
};

export default CensusOverviewService;
